import React, { FC } from 'react';

import {
  Box,
  Flex,
  Modal,
  Button,
  ModalBody,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
} from '@chakra-ui/react';

import { Form, Formik } from 'formik';

import FormikInput from 'components/primitives/FormikInput';
import FormikSelectInput from 'components/primitives/FormikSelectInput';

import { selectors } from 'store/slices/washhub';

import { initialValues, validationSchema } from './AddCustomerModal.utils';

import { AddCustomerModalViewProps } from './AddCustomerModal.props';
import getSortedData from 'utils/getSortedData';

const labelProps = {
  fontSize: '12px',
  color: '#afafaf',
};

const TYPE = ['Site Owner', 'Concessionaire'];

const AddCustomerModalView: FC<AddCustomerModalViewProps> = (props) => {
  const { isOpen, onClose, onCreate, isCreating } = props;

  const washHub = selectors.useSelectedWashHub();

  return (
    <Modal
      size="6xl"
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent borderRadius="30px">
        <ModalCloseButton _focus={{ outline: 'none' }} />
        <ModalHeader color="support.500" textAlign="center">
          Add customer
        </ModalHeader>
        <ModalBody>
          <Flex direction="column" p={6}>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onCreate}>
              {({ isValid }) => (
                <Form>
                  <Flex>
                    <FormikInput
                      name="companyName"
                      label="Company Name(*)"
                      labelProps={labelProps}
                      placeholder="your text here"
                      containerProps={{ flex: 1 }}
                    />
                    <Box h="20px" w="20px" />
                    <FormikSelectInput
                      placeholder="Select a Type"
                      label="Type"
                      name="type"
                      containerProps={{ flex: 1 }}>
                      {getSortedData(TYPE)?.map((s) => (
                        <option key={s} value={s}>
                          {s || ''}
                        </option>
                      ))}
                    </FormikSelectInput>
                    <Box h="20px" w="20px" />
                    <FormikInput
                      name="washHub"
                      label="Wash Hub"
                      labelProps={labelProps}
                      isReadOnly
                      containerProps={{ flex: 1 }}
                      value={washHub?.name || ''}
                    />
                  </Flex>
                  <Flex mt={6}>
                    {/* <Flex maxW="250px" w="100%">
                      <FormikSelectInput
                        isLoading={isLoadingSites}
                        placeholder="Select a Site"
                        label="Sites"
                        name="site">
                        {sites?.map((s) => (
                          <option key={s._id} value={s._id}>
                            {s?.name || ''}
                          </option>
                        ))}
                      </FormikSelectInput>
                    </Flex> */}
                    <Flex maxW="250px" w="100%">
                      <FormikInput
                        name="billingContact"
                        label="Billing Contact"
                        labelProps={labelProps}
                        placeholder="your text here"
                        containerProps={{ flex: 1 }}
                      />
                    </Flex>
                    <Box h="20px" w="20px" />
                    {/* <FormikSelectInput
                      placeholder="Select Collection Point"
                      label="Collection Point"
                      name="collectionPoint"
                      isLoading={isLoadingPoints}>
                      {collectionPoints?.map((c) => (
                        <option key={c._id} value={c._id}>
                          {c?.name || ''}
                        </option>
                      ))}
                    </FormikSelectInput> */}
                  </Flex>
                  <Flex my={12} flexDirection="row" justifyContent="center">
                    <Button
                      variant="outline"
                      marginRight="10px"
                      isDisabled={isCreating}
                      w="134px"
                      onClick={onClose}>
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      isDisabled={!isValid}
                      isLoading={isCreating}
                      w="134px">
                      Create
                    </Button>
                  </Flex>
                </Form>
              )}
            </Formik>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AddCustomerModalView;
